import { IApiResponse } from "../../../../@types/api-response.type"
import { IExperiencesDto } from "../../../../@types/curriculum.type"
import { Api } from "../../ApiConfig"
import { ApiException } from "../../ApiException"
import { getErrorMessage } from "../../../../utils/utils"

export const getAllExperienceReference = async () : Promise<IExperiencesDto[]> => {
  try {
      const { data } = await Api.get<IApiResponse<IExperiencesDto[]>>(`/api/ExperienceSkill/GetAllExperienceReference`)
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar Experiências'))
  }  
}
